import { apiFetch } from '../../../apiClient';
import { apiMap, settings } from '../../../config/constants';
import { showLoaing } from '../../App/state/action'; //遮盖层
import { getSessionDatas } from '../../../utils';
export const FileUploadInfo_Handle = 'FileUploadInfo_Handle';
export const FileUploadInfo_Loading = 'FileUploadInfo_Loading';
export const FileUploadInfo_View = 'FileUploadInfo_View';
export const IsShowFile_loading = 'IsShowFile_loading'

export const fileUploadInfoHandle = (data) =>({
    type: FileUploadInfo_Handle,
    data
});

export const fileUploadInfoLoading = (data) =>({
    type: FileUploadInfo_Loading,
    data
});

export const fileUploadInfoView = (data, questionId) =>({
    type: FileUploadInfo_View,
    data,
    questionId
});

export const showFileloading = (data) => ({
    type: IsShowFile_loading,
    data
})

// 上传文件
/* istanbul ignore next */
export const uploadFile = (file, requestJson, questionId) => dispatch =>{
    const uploadFileParams = {
        hostname: settings.hostnameUploadFile,
        paramsObj: {
            file,
            requestJson
        },
        method: settings.post,
        headers: {
            // 延长timeout时间
            Expect: '100-Continue'
            // test 400问题
            //"X-HSBC-SAML": '<saml:Assertion xmlns:saml="http://www.hsbc.com/saas/assertion"><Signature><KeyAlias>E2E_TRUST_SAAS_NA01_DIT4_ALIAS</KeyAlias><SignatureValue>HHKXEt+GHtqSm46/Iq0sJx+nEpqgv5A+OVmjc57j/JTM1jtDtGDBNdE9EQwAo8Zye0YXSE0A2qNtE0EBneuxGFzCsTY/qbPnTMca9JzaNFFvKhxAJqTSKwQ+5Z5F1orzugaDpqfYITAyX8AEmxeulFu1DffyG8ecixPIePbDiL0rC0hi5pvWv1zwryYdaK/QzUkSQvpKntJlpt4XSnG7DGgksFw6LdoCxOHUOxH2LIqfmR+flGva1CwB7ulwMDDzj8tZtBoin1r58ADx4D0rUU1y6/nlLDR+S2O4DxZNiJzFfo8cxdOxYmNV2Z616RuqI1BO5RAHgnS/mU+lopSNxQ==</SignatureValue></Signature><saml:Subject><saml:NameID>IB1ib5793467</saml:NameID></saml:Subject><saml:Conditions NotBefore="2015-12-08T17:32:06.583Z" NotOnOrAfter="2015-12-08T17:33:06.583Z"></saml:Conditions><saml:AttributeStatement><saml:Attribute Name="IP"><saml:AttributeValue>130.47.61.229</saml:AttributeValue></saml:Attribute><saml:Attribute Name="CAM"><saml:AttributeValue>30</saml:AttributeValue></saml:Attribute></saml:AttributeStatement></saml:Assertion>'
        },
        isUpload: true
    };
    return apiFetch(apiMap.UploadFile, uploadFileParams)(dispatch)
                .then((response) => {
                    return response;
                }).catch((e) => {
                    throw e;
                });
};

// 查询(上传文件)状态
/* istanbul ignore next */
export const getStatusFile = (documentId) => dispatch =>{
    dispatch(showLoaing(true));
    const uploadFileParams = {
        hostname: settings.hostnameStatusUploadFile,
        headers: {
            ...settings.clientHeaders
        }
    }
    return apiFetch(apiMap.getStatusFile(documentId),uploadFileParams)(dispatch)
                .then((response) => {
                    if (response && response.documents){
                        return response.documents;
                    } else {
                        return false;
                    }
                }).catch((e) => {
                    throw e;
                })
};

// 储存(下一步)
/* istanbul ignore next */
export const uploadFileFinish = (data) => (dispatch) => {
    dispatch(showLoaing(true));
    const paramsObj = {
        "businessInfo":{ 
            "appId": getSessionDatas().applicationId,
            ...data
        }
    }
    return apiFetch(apiMap.updateBusiness, {
                method: settings.put,
                hostname: settings.hostBusiness,
                paramsObj
            })(dispatch).then((result) => {
                dispatch(showLoaing(false));
                return true;
            }).catch((e) => {
                dispatch(showLoaing(false));
                throw e;
            });
}

// 查看文件-> 获得Key
/* istanbul ignore next */
export const downloadFlie = (iccmFileNetId) => (dispatch) => {
    return apiFetch(apiMap.getDownloadKey(iccmFileNetId), {
                method: settings.get,
                hostname: settings.hostnameDownloadKey
            })(dispatch).then((result) => {
                return result;
            }).catch((e) => {
                throw e;
            })
}

// 查看文件-> path + Key
/* istanbul ignore next */
export const downloadImageFlie = (value) => (dispatch) => {
    return apiFetch(apiMap.getDownloadFile(value), {
                method: settings.get,
                hostname: settings.hostnameDownloadFlie
            })(dispatch).then((result) => {
                return result;
            }).catch((e) => {
                throw e;
            })
}



// WEBPACK FOOTER //
// ./src/views/FileUploadInfo/state/action.js